import React, { useEffect, useState, useCallback, useMemo } from "react";
import "react-simple-keyboard/build/css/index.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
    ApiKey,
    ApiUrl,
    SessionKey
} from "../../util/Constant.js";
import { filter, map, isEmpty } from "lodash";

import {
    setDisplayLogin,
    setDisplayRegister,
    setBusy,
    setIdle,
    showMessage,
    showResponseMessage
} from "../../redux/AppAction";
import ApiEngine from "util/ApiEngine";

const MemberBenefit = () => {
    const { t, i18n } = useTranslation();
    const _history = useHistory();
    const _dispatch = useDispatch();
    var gameCategories = useSelector((state) => state.gameState.gameCategories);

    const [activeCategory, setActiveCategory] = useState("Casino");
    const [memberProductList, setMemberProductList] = useState([]);
    const [displayMemberProductList, setDisplayMemberProductList] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getCommAndReward();
    }, [])

    const getCommAndReward = async () => {
        setLoading(true);
        setActiveCategory("All");

        try {
            var responseJson = await ApiEngine.get(
                ApiUrl._API_GET_COMMISION_REWARD
            );

            if (responseJson[ApiKey._API_SUCCESS_KEY]) {
                let data = responseJson[ApiKey._API_DATA_KEY];
                // Filter out items where both commission and reward are 0
                let filteredData = data.filter(item => !(item.commission === 0 && item.reward === 0));
                setDisplayMemberProductList(filteredData);
                setMemberProductList(filteredData);
            } else {
                setDisplayMemberProductList([]);
                setMemberProductList([]);
            }
        } catch (error) {
            setDisplayMemberProductList([]);
            setMemberProductList([]);
        } finally {
            setLoading(false);
        }
    }

    const handleCategoryClick = async (categoryName) => {
        _dispatch(setBusy());

        if (activeCategory !== categoryName) {
            setActiveCategory(categoryName);
            let tempDisplayMemberProductList = memberProductList;
            if (categoryName != "All") {
                tempDisplayMemberProductList = memberProductList.filter(x => x.category === categoryName);
            }
            setDisplayMemberProductList(tempDisplayMemberProductList);
        }
        _dispatch(setIdle());
    }

    // Loading spinner component
    const LoadingSpinner = () => (
        <div style={{ textAlign: "center", padding: "20px" }}>
            <div style={{ marginTop: "10px" }}>Loading...</div>
        </div>
    );

    // No data component
    const NoDataMessage = () => (
        <div style={{ textAlign: "center", padding: "20px", color: "#666" }}>
            <div style={{ fontSize: "16px" }}>{t("NO_DATA_FOUND")}</div>
        </div>
    );

    return (
        <div>
            <div className="title-with-blue-under mb-3">{t("MEMBER_BENEFIT")}</div>

            <div>
                {!gameCategories ? (
                    <LoadingSpinner />
                ) : gameCategories.length === 0 ? (
                    <NoDataMessage />
                ) : (
                    <ul className="game-section-v3-category-box list-inline mb-0" onClick={() => localStorage.setItem(SessionKey._ISONLOAD, true)}>
                        {map(gameCategories.filter(x => x.originalTitle !== "Virtual-Sports" && x.originalTitle !== "V.Sports" && x.originalTitle !== "Fish Games"), (item, index) => {
                            return (
                                <li key={"game_categories_" + index} className={activeCategory === item.originalTitle ? "active" : ""} onClick={() => handleCategoryClick(item.originalTitle)}>
                                    <div className="cat-item">
                                        <div className='cat-img'>
                                            <img
                                                //src={`/img/version3/game-section-v3/game-categories/${item.originalTitle}.svg`}
                                                src={"https://cdn.i8global.com/i8app/product-category/icon-" + item.originalTitle + ".svg"}
                                                className='img-responsive'
                                                alt={item.title}
                                            />
                                        </div>
                                        <div className={'cat-details' + (item.originalTitle === "Connect" ? " connect-font" : "")}>{t(item.originalTitle)}</div>
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                )}
            </div>

            <div id="member-benefeit-table-sec" className="member-benefeit-table-div">
                <table className="" style={{ width: "100%" }}>
                    <thead>
                        <tr>
                            <th>{t("GAME_PROVIDER")}</th>
                            <th>{t("COMMISSION")}</th>
                            <th>{t("REWARD")}</th>
                            <th>{t("TOTAL_REBATE")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="4">
                                    <LoadingSpinner />
                                </td>
                            </tr>
                        ) : displayMemberProductList.length === 0 ? (
                            <tr>
                                <td colSpan="4">
                                    <NoDataMessage />
                                </td>
                            </tr>
                        ) : (
                            displayMemberProductList.map((product, index) => (
                                <tr key={`product-row-${index}`}>
                                    <td style={{ display: "flex" }}>
                                        <div>{product.productName}</div>
                                        <div className="cat-title-text">{" (" + product.category + ")"}</div>
                                    </td>
                                    <td>
                                        <div>{product.commission === 0 ? "-" : product.commission.toFixed(2) + "%"}</div>
                                    </td>
                                    <td>
                                        <div>{product.reward === 0 ? "-" : product.reward.toFixed(2) + "%"}</div>
                                    </td>
                                    <td>
                                        <div style={{ fontWeight: "bold" }}>{(product.commission + product.reward).toFixed(2) + "%"}</div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default MemberBenefit;